import { Fragment } from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';

import { Menu, Transition } from '@headlessui/react';
import cx from 'classnames';

import ShareIcon from '~/components/Icons/ShareIcon';

interface Props {
  title: string;
  description?: string;
  url: string;
  iconClassName?: string;
}

const SocialSharer = ({ title, url, iconClassName, description = '' }: Props) => {
  return (
    <Menu as="div" className="relative z-20 inline-block text-left md:z-0">
      <Menu.Button className="relative right-[2px] top-[1.5px] outline-none md:right-[0px]">
        <div className="flex items-center rounded-full p-1 hover:bg-[#f3f4f6]">
          <ShareIcon className={cx(iconClassName, 'h-7 w-7 stroke-1 text-gray-400')} />
        </div>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={cx(
            'absolute bottom-10 left-auto right-0 z-40 origin-top-right divide-y divide-gray-100 rounded-md bg-white p-4 pb-4 pr-2 shadow-lg ring-1 ring-black/5 focus:outline-none md:bottom-auto md:left-4 md:right-auto',
          )}
        >
          <div className="flex w-20 flex-wrap gap-2">
            {/** Email --- this one wasn't workin as a menu item.*/}
            <EmailShareButton subject={title} body={description} url={url}>
              <EmailIcon
                round
                size={30}
                className="rounded-full bg-[#9ca3af] hover:bg-gray-800"
                bgStyle={{
                  fill: 'transparent',
                }}
              />
            </EmailShareButton>

            {/** X */}
            <Menu.Item>
              <TwitterShareButton title={title} url={url}>
                <XIcon
                  round
                  size={30}
                  className="rounded-full bg-[#9ca3af] hover:bg-gray-800"
                  bgStyle={{
                    fill: 'transparent',
                  }}
                />
              </TwitterShareButton>
            </Menu.Item>

            {/** LinkedIn */}
            <Menu.Item>
              <LinkedinShareButton title={title} url={url}>
                <LinkedinIcon
                  round
                  size={30}
                  className="rounded-full bg-[#9ca3af] hover:bg-gray-800"
                  bgStyle={{
                    fill: 'transparent',
                  }}
                />
              </LinkedinShareButton>
            </Menu.Item>

            {/** Facebook */}
            <Menu.Item>
              <FacebookShareButton title={title} url={url}>
                <FacebookIcon
                  round
                  size={30}
                  className="rounded-full bg-[#9ca3af] hover:bg-gray-800"
                  bgStyle={{
                    fill: 'transparent',
                  }}
                />
              </FacebookShareButton>
            </Menu.Item>

            {/** Reddit */}
            <Menu.Item>
              <RedditShareButton title={title} url={url}>
                <RedditIcon
                  round
                  size={30}
                  className="rounded-full bg-[#9ca3af] hover:bg-gray-800"
                  bgStyle={{
                    fill: 'transparent',
                  }}
                />
              </RedditShareButton>
            </Menu.Item>

            {/** Whatsapp */}
            <Menu.Item>
              <WhatsappShareButton title={title} url={url}>
                <WhatsappIcon
                  round
                  size={30}
                  className="rounded-full bg-[#9ca3af] hover:bg-gray-800"
                  bgStyle={{
                    fill: 'transparent',
                  }}
                />
              </WhatsappShareButton>
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default SocialSharer;
